document.addEventListener('DOMContentLoaded', () => {
    const popup = document.querySelector('[data-mg-popup]');
    if (!popup) return;

    const scroller = popup.querySelector('[data-mg-scroller]');
    const slides = Array.from(popup.querySelectorAll('[data-mg-slide]'));
    const thumbs = Array.from(popup.querySelectorAll('[data-mg-thumb]'));
    const currentEl = popup.querySelector('[data-mg-current]');
    const totalEl = popup.querySelector('[data-mg-total]');
    const closeBtns = popup.querySelectorAll('[data-mg-close]');

    const total = slides.length;
    if (totalEl) totalEl.textContent = String(total);

    const setActive = (i) => {
        const idx = Math.max(0, Math.min(total - 1, i));
        if (currentEl) currentEl.textContent = String(idx + 1);
        thumbs.forEach((t) => t.classList.toggle('is-active', Number(t.dataset.mgIndex) === idx));
    };

    const openAt = (idx) => {
        popup.hidden = false;
        document.documentElement.style.overflow = 'hidden';

        const target = slides[idx];
        if (target) scroller.scrollTo({ top: target.offsetTop, behavior: 'instant' });

        setActive(idx);
    };

    const close = () => {
        popup.hidden = true;
        document.documentElement.style.overflow = '';
    };

    closeBtns.forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !popup.hidden) close();
    });

    // Open when clicking an image in the main gallery
    document.querySelectorAll('.media-viewer__item[data-media-type="image"]').forEach((li, idx) => {
        li.addEventListener('click', (e) => {
            // avoid opening if user clicks a video control etc (extra safe)
            if (e.target.closest('button,a')) return;
            openAt(idx);
        });
    });

    // Thumb navigation
    thumbs.forEach((t) => {
        t.addEventListener('click', () => {
            const idx = Number(t.dataset.mgIndex || 0);
            const target = slides[idx];
            if (target) scroller.scrollTo({ top: target.offsetTop, behavior: 'smooth' });
            setActive(idx);
        });
    });

    // Counter updates when slides scroll (IntersectionObserver)
    const thresholds = [0, 0.25, 0.5, 0.75, 1]; // more callbacks [web:135]

    const io = new IntersectionObserver((entries) => {
        // Among all entries that are currently intersecting, choose the most visible
        const visible = entries.filter((e) => e.isIntersecting);
        if (!visible.length) return;

        const best = visible.reduce((a, b) =>
            (a.intersectionRatio > b.intersectionRatio ? a : b)
        );

        const idx = Number(best.target.dataset.mgIndex || 0);
        setActive(idx);
    }, {
        root: scroller,
        threshold: thresholds
    });

    slides.forEach((s) => io.observe(s));

    let raf = null;
    scroller.addEventListener('scroll', () => {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
        // pick slide whose top is closest to scroller top
        const top = scroller.scrollTop;
        let bestIdx = 0;
        let bestDist = Infinity;

        slides.forEach((s, i) => {
        const d = Math.abs(s.offsetTop - top);
        if (d < bestDist) { bestDist = d; bestIdx = i; }
        });

        setActive(bestIdx);
    });
    }, { passive: true });
    
});
